
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function OurProcess() {
  const titleRef = useScrollAnimation();

  // Create refs for all step cards at the top level
  const stepRefs = [
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation()
  ];

  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description: 'We start with a no-obligation consultation to understand your health insurance needs, budget, and coverage preferences.',
      icon: 'ri-chat-3-line'
    },
    {
      number: '02',
      title: 'Plan Comparison',
      description: 'We compare plans from over 20 top-rated carriers, presenting you with options that match your requirements and budget.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '03',
      title: 'Expert Guidance',
      description: 'Our licensed agents explain each plan in detail, answering your questions and helping you make an informed decision.',
      icon: 'ri-user-star-line'
    },
    {
      number: '04',
      title: 'Easy Enrollment',
      description: 'We handle all the paperwork and enrollment process, making it simple and stress-free to get your coverage started.',
      icon: 'ri-file-edit-line'
    },
    {
      number: '05',
      title: 'Ongoing Support',
      description: 'We provide year-round support for claims assistance, policy changes, and any questions that arise throughout the year.',
      icon: 'ri-customer-service-2-line'
    },
    {
      number: '06',
      title: 'Annual Review',
      description: 'We review your coverage annually to ensure it still meets your needs and help you make adjustments if necessary.',
      icon: 'ri-calendar-check-line'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 
          ref={titleRef.ref}
          className={`text-4xl md:text-5xl font-serif font-bold text-center text-primary mb-4 transition-all duration-1000 ${
            titleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          How We Help You
        </h2>
        <p className="text-center text-lg text-gray-600 mb-16 max-w-3xl mx-auto">
          Our proven process makes finding and enrolling in health insurance simple and stress-free
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const cardRef = stepRefs[index];
            
            return (
              <div 
                key={index}
                ref={cardRef.ref}
                className={`bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-500 ${
                  cardRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-4 mb-4">
                  <span className="text-5xl font-bold text-accent/20">{step.number}</span>
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-primary mb-3">{step.title}</h3>
                <p className="text-gray-700 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/contact"
            className="inline-flex items-center gap-2 bg-accent text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-accent/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Your Free Consultation
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
